import { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './LocationMap.css';

// Fix default marker icons broken by webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

function LocationMap({ location }) {
  const [coords, setCoords] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setCoords(null);
    setError(false);

    // Try progressively broader queries: full string, then drop the venue name
    const queries = [location];
    const afterFirstComma = location.indexOf(',');
    if (afterFirstComma !== -1) {
      queries.push(location.slice(afterFirstComma + 1).trim());
    }

    const tryQuery = (index) => {
      if (index >= queries.length) { setError(true); return; }
      fetch(
        `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(queries[index])}&format=json&limit=1&addressdetails=1`,
      )
        .then((res) => res.json())
        .then((data) => {
          if (data.length > 0) {
            setCoords({ lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon) });
          } else {
            tryQuery(index + 1);
          }
        })
        .catch(() => setError(true));
    };

    tryQuery(0);
  }, [location]);

  if (error) return <p className="map-error">Could not load map for this location.</p>;
  if (!coords) return <div className="map-loading">Loading map…</div>;

  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${coords.lat},${coords.lng}`;

  return (
    <>
      <MapContainer center={coords} zoom={14} className="location-map" key={`${coords.lat},${coords.lng}`}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        <Marker position={coords}>
          <Popup>{location}</Popup>
        </Marker>
      </MapContainer>
      <a
        className="map-directions-btn"
        href={directionsUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg className="map-directions-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
        </svg>
        Get directions
      </a>
    </>
  );
}

export default LocationMap;
